/**
 * Normalizes GET /user/profile envelope into flat store shape used by onboarding and layout.
 */
export function buildUserProfile(profileEnvelope) {
  if (!profileEnvelope) {
    return null;
  }

  const {
    isIndividual,
    isOrgMember,
    orgMemberRole,
    individualDetails,
    organizationDetails,
    userType,
  } = profileEnvelope;

  const source = (isIndividual ? individualDetails : organizationDetails) || {};

  return {
    isIndividual,
    isOrgMember,
    orgMemberRole,
    ...source,
    userType,
    isOnboarding: source.registrationStatus !== "Completed",
  };
}
